"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findExtensionPropertyByName = void 0;
function findExtensionPropertyByName(propertyName, extensionProperties) {
    return extensionProperties.find((property) => property.name === propertyName);
}
exports.findExtensionPropertyByName = findExtensionPropertyByName;
//# sourceMappingURL=ExtensionPropertyParser.js.map